import { PAYONEER_STORE_KEY } from "../../store";
import { dispatch, withSelect } from '@wordpress/data';

const initPayoneerComponents = () => dispatch( PAYONEER_STORE_KEY ).initPayoneerComponents();
const payWithPayoneer = () => dispatch( PAYONEER_STORE_KEY ).pay();
const rebootPayoneer = () => dispatch( PAYONEER_STORE_KEY ).reboot();

/**
 * Higher-Order Component that maps the inner component's props to our payoneer store
 */
export const provider = withSelect(
	( select, ownProps ) => {
		const payoneer = select( PAYONEER_STORE_KEY )
		const {
			activePaymentMethod,
			eventRegistration
		} = ownProps
		return {
			activePaymentMethod,
			eventRegistration,
			payWithPayoneer,
			initPayoneerComponents,
			rebootPayoneer,
			isValid: payoneer.getIsValid()
		}
	}
)
